var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconFilesCopyrightSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconFilesCopyright",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M960 0c529.355 0 960 430.645 960 960s-430.645 960-960 960S0 1489.355 0 960 430.645 0 960 0Zm0 112.941c-467.125 0-847.059 379.934-847.059 847.059 0 467.125 379.934 847.059 847.059 847.059 467.125 0 847.059-379.934 847.059-847.059 0-467.125-379.934-847.059-847.059-847.059Zm9.118 620.06c90.587-.06 155.402 35.788 194.567 106.071h.06l-97.941 51.144c-10.523-21.784-23.319-37.07-38.507-45.807-15.307-8.738-29.418-13.106-42.453-13.106-65.294 0-98 43.209-98 129.686 0 39.32 8.31 70.738 24.814 94.317 16.503 23.64 40.898 35.429 73.186 35.429 42.573 0 72.648-20.946 90.048-62.898l90.108 45.842c-19.133 35.847-45.681 64.034-79.644 84.5-33.962 20.588-71.392 30.821-112.351 30.821-65.293 0-117.911-20.11-157.972-60.327C775.03 1088.576 755 1032.676 755 961.04c0-69.9 20.21-125.386 60.75-166.38C856.17 753.544 907.353 733 969.118 733Z",
      fillRule: "evenodd",
      stroke: "#979797"
    })));
  }
}
IconFilesCopyrightSolid.glyphName = 'files-copyright';
IconFilesCopyrightSolid.variant = 'Solid';
IconFilesCopyrightSolid.displayName = 'IconFilesCopyrightSolid';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconFilesCopyrightSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconFilesCopyrightSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconFilesCopyrightSolid;
export { IconFilesCopyrightSolid };